import React from 'react'
import Helmet from 'react-helmet'

import { ADDITIONAL_GTM_ID, GTM_ID, REGION } from '~/config'

const GTM = () => {
  return (
    <>
      <Helmet>
        <script async>
          {`
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${GTM_ID}');
          `}
        </script>
      </Helmet>
      {(REGION.toUpperCase() === 'TW' && ADDITIONAL_GTM_ID) && (
        <Helmet>
          <script async src={`https://www.googletagmanager.com/gtag/js?id=${ADDITIONAL_GTM_ID}`} />
          <script>
            {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${ADDITIONAL_GTM_ID}');
            `}
          </script>
        </Helmet>
      )}
      <noscript>
        <iframe
          title="googletagmanager"
          src={`//www.googletagmanager.com/ns.html?id=${GTM_ID}`}
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
        />
      </noscript>
    </>
  )
}

export default GTM
